import { useTranslation } from "react-i18next";
import { ApiFailure } from "@/api/client.ts";

/** Maps an ApiFailure (or anything) to a translated, user-facing message. */
export function useApiError() {
  const { t } = useTranslation();
  return (err: unknown): string => {
    if (err instanceof ApiFailure) {
      // the server's own explanation (why an account is not usable, why a run did not start) follows the general message
      if (err.code !== "internal" && err.message && err.message !== err.code) return `${t(`errors.${err.code}`)} (${err.message})`;
      return t(`errors.${err.code}`);
    }
    return t("errors.internal");
  };
}
